import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import TabsCarousel from "Components/TabsCarousel";
import SubmitButton from '../Patient/SubmitButton'
import {
  Tabs,
  Row,
  Col,
  Input, Button,Radio,Checkbox,message,Form, Divider,Typography
} from "antd";

import api from "utils/api";
import utils from "utils";
import "./VideoConsultation.scss";
import "./PrescriptionTab.scss";
import { setPublishClicked } from "store/slice/videoConsultation-slice";
import YogaTab from "./YogaTab";
import DietTab from "./DietTab";
import FormPrescription from "./FormPrescription";
const { Text } = Typography;
import { CONSTANTS } from "utils/constant";
import MedicalTestTab from "./MedicalTest/MedicalTestTab";
import PublishPrescriptionPopup from "./MedicalTest/PublishPrescriptionPopup";
const ButtonLists = [{ label: "Allopathy/Ayurveda", value: "allopathy" },
{label:"Medical Test", value:"medical_test"}

];

 class PrescriptionTab extends React.Component {
  form = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      open_publish_modal:false,
      isLoading:true,
      buttonLoading: false,
      is_prescription_done: this.props.prescription_done || false,
      activeTab:0,
      form_action:false,
    prescriptionValue: this.props?.is_prescription_required  == false ? 1 : 2,
    prescription_type:"allopathy",
    disable_type : this.props?.is_prescription_report ? true : this.props?.is_prescription_required == false ? true : false,
    is_prescription_report : this.props?.is_prescription_report,
    is_prescription_publish_status : this.props?.is_prescription_publish_status || "",
    };
    this.addPrescriptionSubmit = this.addPrescriptionSubmit.bind(this);
    this.loadCustomPrescriptionSubmit =
      this.loadCustomPrescriptionSubmit.bind(this);
    this.editPrescription = this.editPrescription.bind(this);
    this.submitPrescription = this.submitPrescription.bind(this);
    this.removePrescription = this.removePrescription.bind(this);
    this.updatePrescripiton = this.updatePrescripiton.bind(this);
    this.handleEditPrescription = this.handleEditPrescription.bind(this);
    this.loadPreDefinedPrescription = this.loadPreDefinedPrescription.bind(this);
    
    //this.updateInfo = this.updateInfo.bind(this);
    //this.switchPrescriptionTabs=this.switchPrescriptionTabs.bind(this)
  }

  loadCustomPrescriptionSubmit(formData) {
    // this.props.location.state.setModule('OTP', { from: 'forgotPassword' });
  }
 
  handleSubmit(action,type,value) {
 
  
   

  if(!action){message.error("Cannot submit empty Prescription!", ErrorDuration) }
  
  api.submit_prescription(value).then(res => {
    if (res.data?.status == 200) {
      //this.props.formAction(false);
      typeof this.props?.visiblePublish == "function" && this.props.visiblePublish()
    //  typeof this.props.handleFunction == "function" && this.props.handleFunction({ is_prescription: true });
      message.success(res.data?.message, ErrorDuration,);
   
    
      if (this.props?.prescription_enable){ this.props.disablePrescription(true)}
    }
  })

}

  

  getPrescription(value) {
    
    let data = {
      "type": value
    };
    api.loadPrescriptionSet(data).then((res) => {
      if (res.data?.status == 200) {
        let finalPrePresctiptionset = (res.data?.data?.results || []).map(obj => ({
          drug_name: obj.drug_name,
          form: obj.form,
          dosage: obj.dosage,
          frequency: obj.frequency,
          duration: obj.duration,
          instruction: obj?.instruction ? obj?.instruction.replace(/(?<=(?:^|[.?!])\W*)[a-z]/g, i => i.toUpperCase()) : "",
          is_allergic: false,
        }))
        this.setState({
          prescriptions: [...finalPrePresctiptionset]
        });
      }
    })
      .catch((err) => {
        console.log("Error is: ", err);
      });
  }
  componentDidMount(){
    this.setState({isLoading:true})
  }
  
 
  componentWillUnmount() {
    this._isMounted = false;
    localStorage.setItem("reloadPrescription", true);
  }
  updatePrescripiton() {
    this.handleSubmit(this.state.temp_prescription_details)
  }

  addPrescriptionSubmit(formData) {

    let local_values = {
      drug_name: formData.drug_name || "",
      form: formData.form || "",
      dosage: formData.dosage.name + " " + formData.dosage.measure || "",
      frequency: formData.frequency || "",
      duration: formData.duration.total + " " + formData.duration.measure || "",
      instruction: formData.instruction || "",
      is_allergic: false,
    };
    this.setState({
      temp_prescription_details: local_values,

    });

    this.setState({
      prescriptions: [
        ...this.state.prescriptions,
        this.state.temp_prescription_details,
      ],
    }); //simple value
    this.form.current?.resetFields();

    this.setState({
      temp_prescription_details: {
        drug_name: "",
        form: "",
        dosage: "",
        frequency: "",
        duration: "",
        instruction: "",
        is_allergic: false,
      },
    });
    this.form.current.setFieldsValue({
      drug_name: "",
      form: "",
      dosage: {
        measure: "",
        name: "",
      },
      duration: {
        measure: "",
        total: "",
      },
      frequency: "",
      instruction: "",
      is_allergic: false,
    });
    this.setState({
      is_edit: false,
    });



    // this.props.location.state.setModule('OTP', { from: 'forgotPassword' });
  }
  handleEditPrescription() {
    if (this.state.is_edit) {
      // console.log(this.state)
    }
  }

  editPrescription(key) {
    // console.log(this.state.selected_type)
    if (this.state.selected_type.length == 0) { message.error("Please select either Allopathy or Ayurveda Prescription type"), ErrorDuration }
    else {
      if (this.state.selected_type.length > 0)
        if (this.state.is_edit) { message.error("Update or Cancel the previous edit to proceed further", ErrorDuration); return; };

      this.setState({
        is_edit: true,
      });
      let previousPrescription = this.state.prescriptions[key];
      this.setState({ temp_prescription_details: previousPrescription, })
      let dosage = previousPrescription?.dosage ? previousPrescription?.dosage.split(" ") : "";
      let duration = previousPrescription.duration.split(" ");
      let new_prescription_details = {
        drug_name: previousPrescription.drug_name,
        dosage: {
          name: dosage[0],
          measure: dosage[1],
        },
        duration: {
          total: duration[0],
          measure: duration[1],
        },
        form: previousPrescription.form,
        frequency: previousPrescription.frequency,
        instruction: previousPrescription.instruction,
        is_allergic: false,

      };

      this.form.current.setFieldsValue({
        drug_name: previousPrescription.drug_name,
        dosage: {
          name: dosage[0],
          measure: dosage[1],
        },
        duration: {
          total: duration[0],
          measure: duration[1],
        },
        form: previousPrescription.form,
        frequency: previousPrescription.frequency,
        instruction: previousPrescription.instruction,
        is_allergic: false,

      });

      let newArray = [...this.state.prescriptions];
      newArray.splice(key, 1);
      this.setState({ prescriptions: newArray, });


    }
  }
  submitPrescription(value) {
    let result = this.props.prescriptionValue === 2 ? true : false;
    if (this.state.is_edit) {
      var prescriptionFormData = this.state.temp_prescription_details

    } else {
      var prescriptionFormData = {
        // appointment_id: this.props.location.state.roomName,
        is_completed: true,
        prescription_mail: false,
        type: this.state?.selected_type || "",
        appointment_id: this.props.appointment_id,
        data: this.state.prescriptions,
        is_prescription_required : true,
      };
      if (this.state.prescriptions.length > 0 && this.state.selectedTab == "allopathy") {
        if (this.state.selected_type.length == 0) {
          // console.log(this.state.selected_type, "ppp")
          message.error("Please select either Allopathy or Ayurveda Prescription Type", ErrorDuration)
        }
        else {
          api
            .prescription_submit(prescriptionFormData)
            .then((res) => {
              if (res.data?.status == 200) {
                typeof this.props?.visiblePublish == "function" && this.props.visiblePublish()
                typeof this.props.handleFunction == "function" && this.props.handleFunction({ is_prescription: true });
                message.success(res.data?.message, ErrorDuration)
                // this.setState({ disable_type: true, allopathy_btn_text: "Update" });
                this.switchPrescriptionTabs("remove",this.state.selectedTab)
            
                if (this.props.disablePrescription) this.props.disablePrescription(true)
                this.setState({
                  edit_prescription_details: {
                    type: "",
                    drug_name: "",
                    form: "",
                    dosage: {
                      measure: "",
                      name: "",
                    },
                    duration: {
                      measure: "",
                      total: "",
                    },
                    frequency: "",
                    instruction: "",
                    is_allergic: false,
                  },
                  prescriptionDone: true,
                  submittedPrescription: true,
                });
                // this.onchangeTab("2");
                this.props.setPrescriptionDone(this.state.prescriptionDone);
                this.setState({
                  is_prescription: result,
                  // prescriptionValue: 1
                });
              }
            })
            .catch((err) => { });
        }
      }
      else {
        // console.log(this.state.is_edit)
        if (this.state.selectedTab == "allopathy" && this.state.prescriptions.length == 0) {
          message.error("Cannot submit empty Prescription!")
          if (this.state.is_edit) message.error("Update or Cancel the previous edit to proceed further!!", ErrorDuration);
        }
      }
    }
  }

  removePrescription(key, clearAll = false) {
    let newArray = [...this.state.prescriptions];
    newArray.splice(key, 1);
    this.setState({ prescriptions: !clearAll ? newArray : [] });
  }

  loadPreDefinedPrescription() {
    api.loadPreDefPrescribtionApi().then((res) => {
      if (res.data?.status == 200) {
        let finalPreDefData = (res.data?.data?.results || []).map(obj => ({
          label: utils.ConvertToPascalCase(obj),
          value: obj
        }));
        this.setState({ predefinedPrescription: finalPreDefData })
          }
    }).catch((err) => { });
  }
  addConsultationSubmit(formData) {
    let result = this.state.consultationValue === 2 ? true : false;
    let consultationFormData = {
      appointment_id: this.props.appointment_id,
      appointment_date_time: formData.consultationTime,
      next_consultation: result,
    };
    api
      .next_consultation_submit(consultationFormData)
      .then((res) => {
        if (res.data?.status == 200) {
          this.setState({
            autoNoConsultation: false,
            consultationValue: 1
          })
          message.success(res.data?.message, ErrorDuration);
        }
      })
      .catch((err) => { });

  }
 /******OLD PRESCRIPTION PUNBLISH****/
  // publishPrescription = () => {
  //   this.setState({buttonLoading: true})
  //   message.warning("Please wait few seconds, generating PDF...", 2);
  
  //   if(this.state.activeTab ==3){
  //     api.
  //     pubish_medical_test({ app_id: this.props.appointment_id, prescription_mail: true }).then((res) => {
  //       if (res.data?.status == 200) {
  //         this.setState({is_prescription_report : true ,disable_type: true })
  //         message.success(res.data?.message, ErrorDuration);
  //         this.setState({buttonLoading: false})
  //       } else {
  //         message.error(res.data?.message, ErrorDuration);
  //         this.setState({buttonLoading: false})
  //       }
  //     })
  //   }else{
  //   api.publish_prescription({ app_id: this.props.appointment_id, prescription_mail: true }).then((res) => {
  //     if (res.data?.status == 200) {
  //       this.setState({is_prescription_report : true ,disable_type: true })
  //       message.success(res.data?.message, ErrorDuration);
  //       this.setState({buttonLoading: false})
  //     } else {
  //       message.error(res.data?.message, ErrorDuration);
  //       this.setState({buttonLoading: false})
  //     }
  //   })
  // }
  // }
  //
  /***********NEW PUBLISH***/
  publishPrescription = (publish_data) =>{
    api.publish_prescription(publish_data)
            .then((res)=>{           
        if(res.status==200){
          typeof this.props?.visiblePublish == "function" && this.props.visiblePublish(false);
          typeof this.props.prescriptionReportFunction == "function" && this.props.prescriptionReportFunction();
          message.warning(res.data?.message, ErrorDuration);
          this.setState({is_prescription_report : true ,disable_type: true ,updateData:true, alreadyPublished : true, buttonLoading: false,visible_publish:false,open_publish_modal:false, is_prescription_publish_status : "in_progress"});
        }
            })
  }
  closePopup = () => {
    this.setState({open_publish_modal:false})
  }
  onSaveNoPrescription=()=>{
    var prescriptionFormData = {
      is_completed: false,
      prescription_mail: false,
      is_prescription_required : false,
      type: "allopathy",
      appointment_id: this.props.appointment_id,
      data: [],
    };
    api
    .prescription_submit(prescriptionFormData)
    .then((res) => {
      typeof this.props.formAction == "function" && this.props.formAction(false)
      if(res.data.status == 200)
      {
      this.setState({disable_type: true});
      typeof this.props.handleFunction == "function" && this.props.handleFunction({ is_prescription_required: false });
      typeof this.props?.visiblePublish == "function" && this.props.visiblePublish(false);
       message.success(res.data.message, ErrorDuration)
      }
      else(
        message.error(res.data.message, ErrorDuration)
      )
    })
  }
handleDoctorSelection(key,index){

  this.setState({activeTab:index})
  // this.props?.setActiveTab(index)
  typeof this.props.setActiveTab == "function" && this.props.setActiveTab(index)
}
handlePrescriptionReport=()=>{
  this.setState({is_prescription_report:true, is_prescription_publish_status : "in_progress"})
}
renderContent(key){
  switch(key){
    case 0:return(
      <FormPrescription prescriptionValue={this.state.prescriptionValue} response={this.state.response} patient_id={this.props?.patient_id || ""} appointment_id={this.props.appointment_id} formAction={this.props.formAction} 
      visiblePublish={typeof this.props.visiblePublish == "function" && this.props.visiblePublish.bind(this)}
      is_prescription_report_update={(val)=> this.setState({is_prescription_report : val , disable_type: true,})}
      handleFunction={typeof this.props.handleFunction == "function" && this.props.handleFunction.bind(this)}
      is_prescription_report={this.state?.is_prescription_report || this.props?.is_prescription_report}
      prescriptionReportFunction = {this.props?.prescriptionReportFunction||  this.handlePrescriptionReport}
      visible_publish = {this.props?.visible_publish} getContainer={this.props?.from != "drawer_prescription" ? {getContainer : false} : {}}></FormPrescription>
      )
   
  
    case 1: 
  
    return(
      <MedicalTestTab 
        from={this.props.from} 
        publishPrescription={this.props?.publishPrescription || this?.publishPrescription}
        is_prescription_report={this.state?.is_prescription_report || this.props?.is_prescription_report} 
        visible_publish = {this.props?.visible_publish} 
        visiblePublish={typeof this.props.visiblePublish == "function" && this.props.visiblePublish.bind(this)} 
        appointment_id={this.props.appointment_id} formAction={this.props.formAction}  
        prescriptionReportFunction = {this.props?.prescriptionReportFunction|| this.handlePrescriptionReport}
     getContainer={this.props?.from != "drawer_prescription" ? {getContainer : false} : {}}
        
         />
    )
  }
}

  render() {
   
    return (
      <>
     
        <div className="required-block">
            <Radio.Group
              defaultValue={this.state.prescriptionValue}
              onChange={(e) =>this.setState({prescriptionValue:e.target.value})}
              value={this.state?.prescriptionValue}
              disabled={this.state.disable_type  || this.props?.is_prescription_report}
            
            >
              <Radio value={2}>Add Prescription</Radio>
              <Radio value={1}>
                No Prescription required for this consultation
              </Radio>
              
            </Radio.Group>


          </div>
          {this.state.prescriptionValue=="2"?
      <Row gutter={24}>
      <Col span={24}>
        <div className="prescription-tab prescription-main-content" >
          
          <div className="carousel-content">
            <div className={this.state?.is_prescription_report ? "no-publish-btn" : "publish-btn"}>
            <TabsCarousel data={ButtonLists} selected={this.state.activeTab}
           disabled={[]}
           handleFunction={this.handleDoctorSelection.bind(this)}
           formAction={this.props.form_action}
           render={(item, index) => { 
         return(
           <div className={`card-container tab-pane`}> 
           <p>{item.label}</p>
           </div>)}} />
           <div className="button-wrapper">
           
           {!this.state?.is_prescription_report  && this.props?.from != "drawer_prescription" && (this.props?.publish_clicked?.[this.props.appointment_id] || this.state.is_prescription_done) ?  
            <SubmitButton label={CONSTANTS.PUBLISH} onClick={()=>this.setState({open_publish_modal:true})} className="update-btn" loading={this.state.buttonLoading}/> :null}
           {/* <Button onClick={this.publishPrescription.bind(this)} className="update-btn">Publish</Button> :null} */}
            {this.state?.is_prescription_report && this.props?.from != "drawer_prescription" && <Text style={{float:"right"}} type="warning">{this.state?.is_prescription_publish_status == 'in_progress' ? CONSTANTS.PRESCRIPTION_PUBLISH_IN_PROGRESS : CONSTANTS.PRESCRIPTION_PUBLISH}</Text>}  
           </div>        
            </div>        
       <div className="tab-content">
        
        {this.renderContent(this.state.activeTab)}
        </div>
        </div>
        </div>
      </Col>
    </Row>:<div>
      <Divider/>
     
    <div className={!this.state.disable_type ? "submit-button-wrapper" : ""}>
      <Button disabled={this.state.disable_type || this.props?.is_prescription_report} style={{float:"right",marginTop:"-15px"}} onClick={()=>this.onSaveNoPrescription()}>Submit</Button>
      </div></div>}
      {this.state.open_publish_modal? 
      <PublishPrescriptionPopup
      app_id={this.props.appointment_id}
      open_publish_modal={this.state.open_publish_modal}
      closePopup={this.closePopup}
      publishPrescription={this.publishPrescription}
      
      />:null}
     
      </>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    publish_clicked: state.videoConsultationReducer.publishClicked
  };
};
const mapDispatchToProps = {
  setPublishClicked
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(PrescriptionTab);